/**
 * The upstream registries a Vibe build's base images can come from, by the host a
 * Dockerfile's `FROM` names.
 *
 * Every image a build pulls goes through the platform's own registry by way of an ECR
 * pull-through cache, and these are the upstreams that cache serves. The cache itself is
 * declared in `apps/vibe-provisioner/mirrored-images.json` (`pullThroughCache.upstreams`,
 * each upstream's FIRST `sources` entry), and the build refusal card names exactly this
 * set to the tenant.
 *
 * 🔴 ONE LIST, TWO READERS, AND A SPEC ON THE SIDE THAT OWNS THE CACHE. The card cannot
 * read the provisioner's JSON — they ship from different repositories — so the frontend
 * reads this list, and the backend's
 * `vibe/infrastructure/nomad/builder/build-and-report.pull-through.spec.ts` holds it
 * equal to the cache declaration. Drop an upstream from the cache and that spec
 * reds; the card never goes on sending tenants to a registry nothing serves.
 */
export const VIBE_BASE_IMAGE_SERVED_REGISTRY_HOSTS = [
  "docker.io",
  "ghcr.io",
  "quay.io",
  "public.ecr.aws",
  "registry.k8s.io"
] as const;

export type VibeBaseImageServedRegistryHost =
  (typeof VIBE_BASE_IMAGE_SERVED_REGISTRY_HOSTS)[number];
